import script from "./Tabbar.vue?vue&type=script&setup=true&lang=js"
export * from "./Tabbar.vue?vue&type=script&setup=true&lang=js"

import "./Tabbar.vue?vue&type=style&index=0&id=0d4712d0&lang=scss&scoped=true"

import exportComponent from "/tmp/tesla_data/tmp/apply_3091/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d4712d0"]])

export default __exports__